var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "transition",
        {
          attrs: { name: "welfareScale" },
          on: {
            "after-leave": function ($event) {
              return _vm.$emit("closed")
            },
          },
        },
        [
          _vm.showContent
            ? _c("div", { ref: "welScaleWrap", staticClass: "bind-wrap" }, [
                _c("div", { staticClass: "welfare-bind" }, [
                  _c("div", {
                    staticClass: "close",
                    on: {
                      click: function ($event) {
                        _vm.showContent = !_vm.showContent
                      },
                    },
                  }),
                  _c("div", { staticClass: "content" }, [
                    _c(
                      "div",
                      { staticClass: "bind-title" },
                      [
                        _vm.isShow
                          ? _c("AutoFontSize", [
                              _vm._v(_vm._s(_vm.$t("welfare_bind_title"))),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "line line-1" },
                      [
                        _vm.isShow
                          ? _c("AutoFontSize", [
                              _vm._v(_vm._s(_vm.$t("welfare_bind_tips_1"))),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "line line-2" }, [
                      _vm._v(_vm._s(_vm.$t("welfare_bind_tips_2"))),
                    ]),
                    _c("div", { staticClass: "award" }),
                    _c(
                      "div",
                      { staticClass: "btn", on: { click: _vm.onBtnBindClick } },
                      [_vm._v(_vm._s(_vm.$t("welfare_bind_btn")))]
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }